import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  keyName: validationNotEmpty("Key Name"),
  keyType: validationNotEmpty("Key Type"),
  keyLength: validationNotEmpty("Key Length"),
});